import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  usersImagesArea: {
    padding: '10px 20px',
    backgroundColor: '#e0e0e0',
    height: '100%',
    color: '#606060',

    display: 'flex',
    alignItems: 'space-between',
    justifyContent: 'space-between',
    flexDirection: 'row'
  },
  usersImagesTitle: {
    marginBottom: 20
  },
  gridList: {
    flexWrap: 'nowrap',
    transform: 'translateZ(0)'
  },
  progressArea: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    justifyItems: 'center',
    flexDirection: 'column'
  },
  usersImagesTitleArea: {
    display: 'flex',
    alignItems: 'space-between',
    justifyContent: 'space-between',
    justifyItems: 'space-between',
    flexDirection: 'row',

    marginBottom: 15
  }
}))

export default useStyles
